import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "close-box-outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-close-box-outline',
    templateUrl: './icon-close-box-outline.component.html',
    styleUrls: ['./icon-close-box-outline.component.scss'],
    standalone: false
})
export class IconCloseBoxOutlineComponent   {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
